import { toast } from "react-toastify";
import { useMutation } from "@apollo/client/react";
import {
  UpdateRuleMutation,
  UpdateRuleMutationVariables,
  UpdateRuleDocument,
} from "@/graphql/__generated__/graphql";
import { useTranslation } from "react-i18next";
import { CustomToastComponent } from "@/components/shared";

export default function useUpdateRuleMutationHook(): {
  updateRuleMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);

  const [updateRuleMutation, { loading, error }] = useMutation<UpdateRuleMutation, UpdateRuleMutationVariables>(
    UpdateRuleDocument, {
      onCompleted() {
        toast(CustomToastComponent, {
          toastId: "rule-updated-success",
          data: {
            title: t("toasts.ruleupdated"),
            type: "success",
          },
        });
      },
    });

  return {
    updateRuleMutation,
    loading,
    error,
  };
}
